import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration, ChartType } from 'chart.js';

@Component({
  selector: 'app-bar-chart',
  standalone: false,
  templateUrl: './bar-chart.component.html',
  styleUrl: './bar-chart.component.scss',
})
export class BarChartComponent implements OnInit {
  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;

  @Input() chartData: ChartConfiguration['data'] = {
    datasets: [],
    labels: [],
  };

  @Input() chartOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 2,
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      x: {
        display: true,
        grid: {
          display: false,
        },
      },
      y: {
        display: true,
        beginAtZero: true,
        grid: {
          color: 'rgba(0, 0, 0, 0.05)',
        },
      },
    },
  };

  @Input() chartTitle = '';
  @Input() height = '300px';
  @Input() horizontal = false;

  public barChartType: ChartType = 'bar';

  ngOnInit(): void {
    if (this.horizontal) {
      this.barChartType = 'bar';
      if (this.chartOptions && this.chartOptions.indexAxis !== 'y') {
        this.chartOptions.indexAxis = 'y';
      }
    }

    if (!this.chartOptions) {
      this.chartOptions = this.getDefaultOptions();
    }
  }

  private getDefaultOptions(): ChartConfiguration['options'] {
    return {
      responsive: true,
      maintainAspectRatio: true,
      aspectRatio: 2,
      indexAxis: this.horizontal ? 'y' : 'x',
      plugins: {
        legend: {
          display: true,
          position: 'top',
        },
        tooltip: {
          mode: 'index',
          intersect: false,
        },
      },
      scales: {
        x: {
          display: true,
          grid: {
            display: false,
          },
        },
        y: {
          display: true,
          beginAtZero: true,
          grid: {
            color: 'rgba(0, 0, 0, 0.05)',
          },
        },
      },
    };
  }

  public updateChart(): void {
    if (this.chart) {
      this.chart.update();
    }
  }
}
